import { render, staticRenderFns } from "./Call-Modal.vue?vue&type=template&id=18d8559e&scoped=true"
import script from "./Call-Modal.vue?vue&type=script&lang=js"
export * from "./Call-Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d8559e",
  null
  
)

export default component.exports